import { useEffect, useMemo, useState } from "react";
import "@/App.css";
import UploadView from "@/pages/UploadView";
import DashboardView from "@/pages/DashboardView";
import { Toaster } from "@/components/ui/sonner";
import AuthGate from "@/components/auth/AuthGate";
import A2HSPrompt from "@/components/A2HSPrompt";
import AdminApp from "@/components/admin/AdminApp";

function App() {
  const [analysis, setAnalysis] = useState(null);

  // Split off /admin as its own top-level app so admin auth is entirely
  // isolated from the main WebAuthn-based flow. We use `pathname` (not a
  // hash or query) so the route is bookmarkable and can be deep-linked.
  const isAdminRoute = useMemo(() => {
    if (typeof window === "undefined") return false;
    return window.location.pathname.replace(/\/+$/, "") === "/admin";
  }, []);

  // Remove the platform-injected "Made with Emergent" badge from the DOM.
  useEffect(() => {
    const removeBadge = () => {
      const el = document.getElementById("emergent-badge");
      if (el) el.remove();
    };
    removeBadge();
    const observer = new MutationObserver(removeBadge);
    observer.observe(document.body, { childList: true, subtree: false });
    return () => observer.disconnect();
  }, []);

  if (isAdminRoute) {
    return (
      <div className="App min-h-screen bg-[#F7F3EC]">
        <AdminApp />
        <Toaster richColors position="top-right" />
      </div>
    );
  }

  return (
    <div className="App min-h-screen bg-[#F7F3EC]">
      <AuthGate>
        {analysis ? (
          <DashboardView
            analysis={analysis}
            onReset={() => setAnalysis(null)}
          />
        ) : (
          <UploadView onAnalysisReady={setAnalysis} />
        )}
      </AuthGate>
      <Toaster
        richColors
        position="top-right"
        offset={`max(60px, calc(1rem + env(safe-area-inset-top)))`}
        mobileOffset={{ top: `max(60px, calc(1rem + env(safe-area-inset-top)))`, right: "1rem", left: "1rem" }}
      />
      <A2HSPrompt />
    </div>
  );
}

export default App;
